import React, { FC } from 'react'

import { css } from '@emotion/core'
import Relazsizes from 'relazsizes'
import Typography from 'components/common/atoms/Typography'

type TestimonyProps = {
  campus: string
  img: string
  name: string
  testimony: string
  title: string
  color?: string
}

const testimonyStyle = css`
  .testimony {
    &__wrapper {
      text-align: center;
    }
    &__img {
      width: 120px;
      height: 120px;
      border-radius: 100%;
      margin: auto;
      display: block;
    }
    &__description {
      margin-top: 24px;
    }
    &__identity {
      margin: 16px 0 40px 0;
    }
    @media screen and (min-width: 768px) {
      &__description {
        margin-top: 40px;
      }
      &__identity {
        margin: 24px 0 40px 0;
      }
    }
  }
`

const Testimony: FC<TestimonyProps> = ({ campus, color = '#fff', img, name, testimony, title }) => (
  <div className="testimony" css={testimonyStyle}>
    <div className="testimony__wrapper">
      <Relazsizes dataSrc={img || '/next-assets/images/placeholder_user.svg'} alt={name} className="testimony__img" />
      <Typography variant="paragraph" level="1" tagName="p" color={color} className="testimony__description">
        {`${testimony}`}
      </Typography>
      <Typography variant="body" level="1" tagName="p" fontWeight="bold" color={color} className="testimony__identity">
        {`${name} - ${title} - ${campus}`}
      </Typography>
    </div>
  </div>
)

export default Testimony
